import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

type SortOption = 'newest' | 'oldest' | 'alphabetical';

export const PortfolioSort = ({ 
  onSort 
}: { 
  onSort: (value: SortOption) => void 
}) => {
  return (
    <div className="w-full md:w-auto">
      <Select onValueChange={onSort} defaultValue="newest">
        <SelectTrigger className="w-full bg-gray-900/50 border-gray-700 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent className="bg-gray-900 border-gray-700">
          <SelectItem 
            value="newest" 
            className="hover:bg-gray-800 focus:bg-gray-800 transition-colors"
          >
            Newest First
          </SelectItem>
          <SelectItem 
            value="oldest" 
            className="hover:bg-gray-800 focus:bg-gray-800 transition-colors"
          >
            Oldest First
          </SelectItem>
          <SelectItem 
            value="alphabetical" 
            className="hover:bg-gray-800 focus:bg-gray-800 transition-colors"
          >
            A-Z
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
